// javascript/controllers/product-item.js
import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["value", "total"];
  }

  connect() {}
  disconnect() {}

  add(event) {
    let max = parseInt(this.data.get("max"));
    let value = parseInt(event.target.dataset.value);
    let current = parseInt(this.valueTarget.value);
    if (current + value >= max) {
      this.valueTarget.value = max;
      this.totalTarget.value = max;
    } else {
      this.valueTarget.value = current + value;
      this.totalTarget.value = current + value;
    }
  }

  change(event) {
    let value = parseInt(event.target.dataset.value);

    this.valueTarget.value = `${value},00`;
    this.totalTarget.value = `${value},00`;
  }

  choose(event) {

    let value = event.target.dataset.value;
    this.valueTarget.value = value;
    this.totalTarget.value = value;

    for(var i = 0; i < 15; i++){
      var btnId = this.element.id.replace('item_','btn_');
      btnId = btnId +'_'+i
      var elm = document.getElementById(btnId);
      if(elm){
        var btnValue = elm.innerText.replace(',', '.').replace(/[^0-9.]/g, '');
        if(elm.classList.contains('item-fixed-btn-selected')){
          elm.classList.remove('item-fixed-btn-selected');
        }
        if(value == (btnValue)){
          elm.classList.add('item-fixed-btn-selected');
          $("#btn-generate").attr("disabled", false);
        }
      }
    }
  }

  clear(event) {
    let min = parseInt(this.data.get("min"));
    let max = parseInt(this.data.get("max"));
    let defaultValue = Math.min(Math.max(50, min), max);
    this.valueTarget.value = `${defaultValue},00`;
    this.totalTarget.value = `${defaultValue},00`;
  }

  check(event) {

    let currency = $("#product_currency").text();
    let value_in_foreign_currency = new Intl.NumberFormat('pt-BR',{
      style: 'currency',
      currency: currency
    });

    let element = this.totalTarget;
    let valueText = element.value;
    let step = element.step;

    let value = valueText.replace(".","").replace(",",".");

    let max = parseInt(this.data.get("max"));
    let min = parseInt(this.data.get("min"));

    if(value > max){
      this.valueTarget.value = max;
      this.totalTarget.value = max;
      $("#mockup-value").text(value_in_foreign_currency.format(max).replace(/^([\d,.]+)/, '$1 ').replace(/\s+/g, ' '));
    }else if(value < min){
      this.valueTarget.value = min;
      this.totalTarget.value = min;
      $("#mockup-value").text(value_in_foreign_currency.format(min).replace(/^([\d,.]+)/, '$1 ').replace(/\s+/g, ' '));
    }else{
      let roundedValue = Math.round(Math.ceil(value / step) * step * 100) / 100;
      let roundedValueText = String((roundedValue).toFixed(2)).replace('.', ',');
      $("#mockup-value").text(value_in_foreign_currency.format(roundedValue).replace(/^([\d,.]+)/, '$1 ').replace(/\s+/g, ' '));
      this.valueTarget.value = roundedValueText;
      this.totalTarget.value = roundedValueText;
    }

  }

  onSuccess(event) {
    let [data, status, xhr] = event.detail;
  }

  onError(event) {
    let [data, status, xhr] = event.detail;
  }
}

